import { registerQuery } from 'data-fetching-client';
import { getUserAttributeRequest, HAS_USED_AI_TRANSLATION_KEY } from 'email-management-lib/refactor/api/userAttributes';
export const FETCH_USER_HAS_USED_AI_TRANSLATION_REQUEST = registerQuery({
  fieldName: 'hasUsedAiTranslation',
  fetcher() {
    return getUserAttributeRequest(HAS_USED_AI_TRANSLATION_KEY);
  }
});